// extracted by mini-css-extract-plugin
export default {"dropdownFilter":"tkZGfrXroOYguwX8UtKg","dropdownFilter__badgeContainer":"lwuYvIJv80eP_4fiqU6k"};